"use strict";
module.exports = require('../../module.compiled').vendored['contexts'].AppRouterContext;

//# sourceMappingURL=app-router-context.js.map